var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeisure(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 36,
    viewBox: "0 0 56 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.992 35.579H51.6835V6.37H55.986V0H0V6.37H50.2295V34.125H27.3625V12.855H11.026V34.125H5.446V6.37H3.992V35.579ZM12.48 14.3095V34.125H18.467V14.3095H12.48ZM19.9215 14.3095V34.125H25.908V14.3095H19.9215ZM47.2045 31.4555V12.855H30.868V31.4555H47.2045ZM32.322 14.3095V30.0015H45.75V14.3095H32.322ZM46.8975 1.454V4.916H54.532V1.454H46.8975ZM37.8085 1.454V4.916H45.443V1.454H37.8085ZM28.72 1.454V4.916H36.3545V1.454H28.72ZM19.6315 1.454V4.916H27.266V1.454H19.6315ZM10.543 1.454V4.916H18.1775V1.454H10.543ZM1.454 1.454V4.916H9.0885V1.454H1.454Z",
    fill: "#255056"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeisure);
export default __webpack_public_path__ + "static/media/leisure.3a02d5f2413659597689ba031a5bee24.svg";
export { ForwardRef as ReactComponent };